module.exports = __webpack_public_path__ + "static/media/Basic.5037a6d4.svg";